<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" class="v-balls" :class="{ active: isActive }">
    <circle v-for="ball in balls" :cx="ball.x" :cy="ball.y" :r="ball.radius" />
</svg>
